import { useNavigate } from 'react-router';
import { Reportformat } from '@/features/settings/Reportformat';
import { SideMenuPage } from '@/features/taxreturn/menus/SideMenuPage';
import { SETTINGS_ROUTE, useReportClient } from './common';
import { REPORT_SETTINGS_NOTE } from './StickyReportSettingsFrame';
import './StickyReportSettingsFrame.scss';

/**
 * Client > Settings > Report Format (BUG-074): this client's own report fonts, headings and rounding, over the firm's.
 * The page's own header carries the one title, so it is not wrapped in the titled Report Settings frame (that put a second
 * title and an indented band above it).
 */
export function ClientReportFormat() {
  const navigate = useNavigate();
  const client = useReportClient();

  return (
    <SideMenuPage menu="settings">
      {client && (
        <Reportformat clientId={client.id} intro={REPORT_SETTINGS_NOTE} onClose={() => void navigate(SETTINGS_ROUTE)} />
      )}
    </SideMenuPage>
  );
}
